export default {

  get: (src, onSuccess) => {

    const script = document.createElement('script')

    script.src = src
    script.async = true
    script.onerror = e => console.log(`Error loading ${src}`, e)
    script.onload = () => onSuccess()

    document.body.appendChild(script)

  }

}
